// Autogenerated file
const translationKeys = {
  dnb_header_menu_button: 'dnb_header_menu_button',
};

Object.freeze(translationKeys);

export default translationKeys;
